import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { clasePerdidaReducer } from './state/clase-perdida.reducer';
import { ClasePerdidaEffects } from './state/clase-perdida.effects';
import { ClasePerdidaShellComponent } from './shell/clase-perdida-shell.component';
import { ClasePerdidaModal } from './modal/clase-perdida-modal.component';
import { ClasePerdidaListComponent } from './list/clase-perdida-list.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ClasePerdidaMaterialModule } from './clase-perdida-material.module';

@NgModule({
  declarations: [
    ClasePerdidaShellComponent,
    ClasePerdidaListComponent,
    ClasePerdidaModal,
  ],
  imports: [
    CommonModule,
    ClasePerdidaMaterialModule,
    ReactiveFormsModule,

    StoreModule.forFeature('clasePerdidas', clasePerdidaReducer),
    EffectsModule.forFeature([ClasePerdidaEffects]),
  ],
  exports: [
    ClasePerdidaShellComponent,
  ],
})
export class ClasePerdidaModule { }
